import { Button } from '@/components/ui/atoms/button'
import Search from '@/components/ui/molecules/search'
import SearchTerms from '@/components/ui/molecules/search-terms'
import { navigate } from '@/lib/client'

export default function ProductsHeaderSearch({
  teachers,
  areas,
  type,
  breadcrumbs,
  search,
  pathname,
}: {
  teachers: Array<{ _id: string; name: string }>
  areas: Array<{ value: string; label: string }>
  type: string
  breadcrumbs: Array<{ name: string; href: string }>
  search?: string
  pathname: string
}) {
  const current = new URLSearchParams(search)
  const currentPath = pathname

  const selected = [
    {
      type: 'name',
      value: current.get('name'),
    },
    {
      type: 'career',
      value:
        areas.length && current.get('career')
          ? `Área = ${areas.find((t) => t.value === current.get('career'))?.label}`
          : null,
    },
    {
      type: 'professor',
      value:
        teachers.length && current.get('professor')
          ? `Professor(a) = ${teachers.find((t) => t._id === current.get('professor'))?.name}`
          : null,
    },
  ]

  const handleSearch = (search: { value: string; type: string }) => {
    if (search.value === '0') current.delete(search.type)
    else {
      if (search.type === 'free') current.set('name', search.value)
      if (search.type === 'career')
        current.set(
          'career',
          areas.find(
            (a) => a.label?.toLowerCase() === search?.value?.toLowerCase(),
          )?.value || '',
        )
      if (search.type === 'professor')
        current.set(
          'professor',
          teachers.find(
            (t) => t.name?.toLowerCase() === search?.value?.toLowerCase(),
          )?._id || '',
        )
    }

    const parsed = current.toString()
    const query = parsed ? `?${parsed}` : ''

    navigate(`/${currentPath}${query}`)
  }

  const definitions = {
    curso: {
      variant: (currentPath === 'cursos' ? 'secondary' : 'ghost') as
        | 'ghost'
        | 'secondary',
      class:
        currentPath === 'cursos'
          ? 'text-white bg-zinc-50/10 hover:bg-zinc-50/20'
          : 'text-zinc-300 hover:bg-transparent hover:text-white',
    },
    modulo: {
      variant: (currentPath === 'modulos' ? 'secondary' : 'ghost') as
        | 'ghost'
        | 'secondary',
      class:
        currentPath === 'modulos'
          ? 'text-white bg-zinc-50/10 hover:bg-zinc-50/20'
          : 'text-zinc-300 hover:bg-transparent hover:text-white',
    },
    concurso: {
      variant: (currentPath === 'concursos' ? 'secondary' : 'ghost') as
        | 'ghost'
        | 'secondary',
      class:
        currentPath === 'concursos'
          ? 'text-white bg-zinc-50/10 hover:bg-zinc-50/20'
          : 'text-zinc-300 hover:bg-transparent hover:text-whiteult',
    },
  }

  return (
    <>
      <Search
        placeholder={`Pesquise por ${type}, professor ou área...`}
        suggestions={[
          {
            heading: 'Áreas',
            items: areas
              .filter((a) => a.value !== '0')
              .map((t) => ({
                type: 'career',
                value: t.value,
                label: t.label,
              })),
          },
          {
            heading: 'Professores',
            items: teachers.map((t) => ({
              type: 'professor',
              value: t._id,
              label: t.name,
            })),
          },
        ]}
        handleSearch={handleSearch}
      />

      <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0 lg:space-x-4 my-4">
        <div className="flex justify-center mb-4 md:mb-0">
          <SearchTerms
            href={breadcrumbs[1]?.href}
            handleSearch={handleSearch}
            selected={selected?.filter((t) => t.value)}
          />
        </div>

        <div className="flex justify-center">
          <Button
            size={'sm'}
            asChild
            variant={definitions.curso.variant}
            className={definitions.curso.class}
          >
            <a aria-label="cursos" href="/cursos">
              Cursos
            </a>
          </Button>
          <Button
            size={'sm'}
            asChild
            variant={definitions.modulo.variant}
            className={definitions.modulo.class}
          >
            <a aria-label="modulos" href="/modulos">
              Módulos
            </a>
          </Button>
          <Button
            size={'sm'}
            asChild
            variant={definitions.concurso.variant}
            className={definitions.concurso.class}
          >
            <a aria-label="concursos" href="/concursos">
              Concursos
            </a>
          </Button>
        </div>
      </div>
    </>
  )
}
